import { RouteInfo } from "./sidebar.metadata";

export const ROUTES: RouteInfo[] = [
  {
    path: "/user/dashboard",
    title: "Dashboard",
    icon: "mdi mdi-view-dashboard",
    class: "",
    extralink: false,
    submenu: [],
  },
  {
    path: "user/users-booking",
    title: "Users/Customers",
    icon: "mdi mdi-account",
    class: "has-arrow",
    extralink: false,
    submenu: [
      {
        path: "user/users-booking",
        title: "User Bookings",
        icon: "fa fa-user-plus",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "user/users-advance-booking",
        title: "User Advance Bookings",
        icon: "fa fa-user-plus",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/transactions",
        title: "Transactions",
        icon: "mdi mdi-wallet",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/news-letter",
        title: "Newsletter",
        icon: "mdi mdi-playlist-check",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/customer-review",
        title: "Customer Review",
        icon: "mdi mdi-star",
        class: "",
        extralink: false,
        submenu: [],
      },
    ],
  },
  {
    path: "/user/employee",
    title: "Employee",
    icon: "mdi mdi-account-multiple",
    class: "",
    extralink: false,
    submenu: [],
  },
  {
    path: "/user/membership",
    title: "Membership",
    icon: "mdi mdi-wallet",
    class: "has-arrow",
    extralink: false,
    submenu: [
      {
        path: "/user/membership",
        title: "Membership",
        icon: "mdi mdi-wallet",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/user-membership",
        title: "User Membership",
        icon: "mdi mdi-domain",
        class: "",
        extralink: false,
        submenu: [],
      },
    ],
  },
  {
    path: "/user/vending-product",
    title: "Vending",
    icon: "mdi mdi-domain",
    class: "has-arrow",
    extralink: false,
    submenu: [
      {
        path: "/user/vending-product",
        title: "Product Info",
        icon: "mdi mdi-domain",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/vending-store",
        title: "Store Info",
        icon: "mdi mdi-domain",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/charity-organization",
        title: "Charity Organization",
        icon: "mdi mdi-domain",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/charity-transaction",
        title: "Charity Transactions",
        icon: "mdi mdi-domain",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/charity-settlements",
        title: "Charity Settlements",
        icon: "mdi mdi-domain",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/vending-orders",
        title: "Order Management",
        icon: "mdi mdi-domain",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/vending-category",
        title: "Vending Category",
        icon: "mdi mdi-domain",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/express-shipping",
        title: "Express shipping",
        icon: "mdi mdi-domain",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/festivals",
        title: "Festivals",
        icon: "mdi mdi-domain",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/lottery",
        title: "Lottery",
        icon: "mdi mdi-ticket",
        class: "",
        extralink: false,
        submenu: [],
      },
    ],
  },
  {
    path: "/user/pos-orders",
    title: "ATZ POS",
    icon: "mdi mdi-domain",
    class: "has-arrow",
    extralink: false,
    submenu: [
      {
        path: "/user/pos-orders",
        title: "Order Management",
        icon: "mdi mdi-domain",
        class: "",
        extralink: false,
        submenu: [],
      },
    ],
  },
  {
    path: "/user/spot-booking",
    title: "Spot Booking",
    icon: "fa fa-book",
    class: "has-arrow",
    extralink: false,
    submenu: [
      {
        path: "/user/spot-booking",
        title: "Spot Booking",
        icon: "fa fa-book",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/manage-spot-booking",
        title: "Spot Management",
        icon: "fa fa-book",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/manage-spot-refund",
        title: "Spot Refund",
        icon: "fa fa-book",
        class: "",
        extralink: false,
        submenu: [],
      },
    ],
  },
  {
    path: "/user/rent-package",
    title: "Packages",
    icon: "mdi mdi-package",
    class: "has-arrow",
    extralink: false,
    submenu: [
      {
        path: "/user/rent-package",
        title: "Rent Package",
        icon: "mdi mdi-package-up",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/book_package",
        title: "Book Package",
        icon: "mdi mdi-package-up",
        class: "",
        extralink: false,
        submenu: [],
      },

      {
        path: "/user/sale-package",
        title: "Sale Package",
        icon: "mdi mdi-package-up",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/advance_booking",
        title: "Advance Booking",
        icon: "fa fa-book",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/request_payment",
        title: "Request Payment",
        icon: "fa fa-credit-card",
        class: "",
        extralink: false,
        submenu: [],
      },

      {
        path: "/user/package_addon",
        title: "Addon Package",
        icon: "mdi mdi-package-variant-closed",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/pay-later-payment",
        title: "Pay Later Payments",
        icon: "fa fa-cart-plus",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/coupon_code",
        title: "Coupon Code For All Packages",
        icon: "mdi mdi-ticket-percent",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/used-coupons",
        title: "Used Coupon codes",
        icon: "mdi mdi-ticket-percent",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/warning-feature",
        title: "Warning Feature",
        icon: "mdi mdi-account-alert",
        class: "",
        extralink: false,
        submenu: [],
      },
    ],
  },
  {
    path: "/user/assets",
    title: "Assets",
    icon: "fas fa-location-arrow",
    class: "has-arrow",
    extralink: false,
    submenu: [
      {
        path: "/user/assets",
        title: "Assets",
        icon: "fas fa-location-arrow",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/my-assets",
        title: "My assets",
        icon: "fa fa-solid fa-thumbtack",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/track-assets",
        title: "Track Assets",
        icon: "fa fa-truck",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/parking-violation",
        title: "Parking Violation",
        icon: "mdi mdi-label",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/geofence",
        title: "Geofence",
        icon: "fa fa-map-marker",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/operation",
        title: "Put into Operation",
        icon: "mdi mdi-star-circle",
        class: "",
        extralink: false,
        submenu: [],
      },
    ],
  },
  {
    path: "/user/payment-method",
    title: "Payment",
    icon: "mdi mdi-wallet",
    class: "has-arrow",
    extralink: false,
    submenu: [
      {
        path: "/user/payment-method",
        title: "Payment Method",
        icon: "mdi mdi-wallet",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/add-payment",
        title: "Add Payment account",
        icon: "mdi mdi-wallet",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/pending-amount",
        title: "Pending Amount",
        icon: "mdi mdi-wallet",
        class: "",
        extralink: false,
        submenu: [],
      },
    ],
  },
  {
    path: "/user/waiver-forms",
    title: "Waiver forms",
    icon: "mdi mdi-car",
    class: "has-arrow",
    extralink: false,
    submenu: [
      {
        path: "/user/waiver-forms",
        title: "Waiver Forms(Customer)",
        icon: "mdi mdi-format-align-justify",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/waiver-terms/frekis",
        title: "Waiver forms (Frekis)",
        icon: "mdi mdi-arrange-bring-forward",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/waiver-terms/sharekayak",
        title: "Waiver forms (Sharekayak)",
        icon: "mdi mdi-arrange-bring-forward",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/waiver-terms/shrvee",
        title: "Waiver forms (Shrvee Services)",
        icon: "mdi mdi-arrange-bring-forward",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/license",
        title: "License",
        icon: "mdi mdi-file-lock",
        class: "",
        extralink: false,
        submenu: [],
      },
    ],
  },
  {
    path: "/user/my-ride-history",
    title: "History",
    icon: "mdi mdi-history",
    class: "has-arrow",
    extralink: false,
    submenu: [
      {
        path: "/user/my-ride-history",
        title: "My Ride History",
        icon: "mdi mdi-arrange-bring-forward",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/my-asset-ride-history",
        title: "My Asset Ride History",
        icon: "mdi mdi-arrange-bring-forward",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/my-book-history",
        title: "My Book History",
        icon: "mdi mdi-arrange-bring-forward",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/lock-fallback",
        title: "Lock Fallback History",
        icon: "mdi mdi-lock",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/purchase-history",
        title: "Purchase History",
        icon: "mdi mdi-alert-circle",
        class: "",
        extralink: false,
        submenu: [],
      },
    ],
  },
  {
    path: "/user/locations",
    title: "Locations",
    icon: "mdi mdi-bell-ring",
    class: "",
    extralink: false,
    submenu: [],
  },
  {
    path: "/user/notifications",
    title: "Notifications",
    icon: "mdi mdi-bell-ring",
    class: "",
    extralink: false,
    submenu: [],
  },
  {
    path: "/user/privacy-policy",
    title: "Platform Support",
    icon: "fa fa-question-circle",
    class: "has-arrow",
    extralink: false,
    submenu: [
      {
        path: "/user/privacy-policy",
        title: "Privacy-policy",
        icon: "fa fa-user-secret",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/term-conditions",
        title: "Term & Conditions",
        icon: "fa fa-user-secret",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/support/faq",
        title: "FAQ",
        icon: "fa fa-solid fa-question",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/support/operator-support",
        title: "Operator Support",
        icon: "fa fa-solid fa-question",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/support/feedback",
        title: "Feedback",
        icon: "fa fa-solid fa-question",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/pludda",
        title: "Pludda",
        icon: "mdi mdi-archive",
        class: "",
        extralink: false,
        submenu: [],
      },
      {
        path: "/user/external-api",
        title: "External Apis",
        icon: "mdi mdi-format-align-justify",
        class: "",
        extralink: false,
        submenu: [],
      },
    ],
  },

  // {
  //   path: "/user/users",
  //   title: "On Boarding",
  //   icon: "fas fa-briefcase",
  //   class: "has-arrow",
  //   extralink: false,
  //   submenu: [
  //     {
  //       path: "/user/business-profile",
  //       title: "Update your profile",
  //       icon: "mdi mdi-adjust",
  //       class: "",
  //       extralink: false,
  //       submenu: [],
  //     },
  //   ],
  // },

  // {
  //   path: "/user/help-faq",
  //   title: "Support",
  //   icon: "mdi mdi-headset",
  //   class: "has-arrow",
  //   extralink: false,
  //   submenu: [],
  // },

  ///////////////////////////////////////
  // {
  //   path: '/custom-changes',
  //   title: 'Custom Changes',
  //   icon: 'mdi mdi-adjust',
  //   class: '',
  //   extralink: true,
  //   submenu: []
  // },
  // {
  //   path: '',
  //   title: 'Component',
  //   icon: 'mdi mdi-bullseye',
  //   class: 'has-arrow',
  //   extralink: false,
  //   submenu: [
  //     {
  //       path: '/component/accordion',
  //       title: 'Accordion',
  //       icon: 'mdi mdi-adjust',
  //       class: '',
  //       extralink: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/component/alert',
  //       title: 'Alert',
  //       icon: 'mdi mdi-adjust',
  //       class: '',
  //       extralink: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/component/carousel',
  //       title: 'Carousel',
  //       icon: 'mdi mdi-adjust',
  //       class: '',
  //       extralink: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/component/dropdown',
  //       title: 'Dropdown',
  //       icon: 'mdi mdi-adjust',
  //       class: '',
  //       extralink: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/component/modal',
  //       title: 'Modal',
  //       icon: 'mdi mdi-adjust',
  //       class: '',
  //       extralink: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/component/pagination',
  //       title: 'Pagination',
  //       icon: 'mdi mdi-adjust',
  //       class: '',
  //       extralink: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/component/poptool',
  //       title: 'Popover & Tooltip',
  //       icon: 'mdi mdi-adjust',
  //       class: '',
  //       extralink: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/component/progressbar',
  //       title: 'Progressbar',
  //       icon: 'mdi mdi-adjust',
  //       class: '',
  //       extralink: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/component/rating',
  //       title: 'Ratings',
  //       icon: 'mdi mdi-adjust',
  //       class: '',
  //       extralink: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/component/tabs',
  //       title: 'Tabs',
  //       icon: 'mdi mdi-adjust',
  //       class: '',
  //       extralink: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/component/timepicker',
  //       title: 'Timepicker',
  //       icon: 'mdi mdi-adjust',
  //       class: '',
  //       extralink: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/component/buttons',
  //       title: 'Button',
  //       icon: 'mdi mdi-adjust',
  //       class: '',
  //       extralink: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/component/cards',
  //       title: 'Card',
  //       icon: 'mdi mdi-adjust',
  //       class: '',
  //       extralink: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/component/notifier',
  //       title: 'Notifier',
  //       icon: 'mdi mdi-adjust',
  //       class: '',
  //       extralink: false,
  //       submenu: []
  //     }
  //   ]
  // }
];
